/**
 * 新闻相关API接口
 * 实现新闻发布、查询、修改等功能
 */

import { req } from '../utils/request'

export class News {
  /**
   * 发布新闻（理事）
   * @param {Object} data - { title, content, img, keywords, description }
   * @returns {Promise}
   */
  publishNews(data) {
    return req.post('user.news/publish', data)
  }
  
  /**
   * 获取我的新闻列表（理事）
   * @param {Object} params - { status, is_draft, page, limit }
   * @returns {Promise}
   */
  getMyNews(params) {
    return req.get('user.news/myList', params)
  }
  
  /**
   * 修改新闻（理事）
   * @param {Number} id - 新闻ID
   * @param {Object} data - 新闻数据
   * @returns {Promise}
   */
  updateNews(id, data) {
    return req.post('user.news/update', { id, ...data })
  }
  
  /**
   * 删除新闻（理事）
   * @param {Number} id - 新闻ID
   * @returns {Promise}
   */
  deleteNews(id) {
    return req.post('user.news/delete', { id })
  }
  
  /**
   * 获取公开新闻列表
   * @param {Object} params - { cid, is_top, is_hot, page, limit }
   * @returns {Promise}
   */
  getPublicNews(params) {
    return req.get('user.news/publicList', params)
  }
  
  /**
   * 获取新闻详情
   * @param {Number} id - 新闻ID
   * @returns {Promise}
   */
  getNewsDetail(id) {
    return req.get('user.news/detail', { id })
  }
}

export default new News()
